export class UniversityCardModel {
  id: string = ''
  name?: string = ''
  image?: string = ''
  programs?: string = ''
  price?: string = ''
  slug?: string = ''
}
